import styled from '@mui/material/styles/styled';
import { Link } from 'react-router-dom';

import { LAYOUT_WIDTH } from '../../layouts/constants';

export const StyledLink = styled(Link)(({ open, theme }) => ({
  overflow: 'hidden',
  boxSizing: 'border-box',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  background: '#fff',
  paddingTop: theme.spacing(0.5),
  paddingLeft: open ? theme.spacing(1) : 0,
  width: open ? LAYOUT_WIDTH.MAX : LAYOUT_WIDTH.MIN,
  transition: theme.transitions.create(['padding', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.shorter,
  }),
  ...theme.mixins.toolbar,
}));

export const StyleSideBarBrand = styled('div')(({ open, theme }) => ({
  flexShrink: 0,
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  '& .nav-brand-image': {
    paddingLeft: open ? 0 : 11,
    transition: theme.transitions.create('padding', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.shorter,
    }),
  },
  '& .nav-brand-name': {
    marginLeft: open ? 0 : 5,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.shorter,
    }),
  },
}));
